var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgC2DoorOpen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55 58V11H22.24l-.24-.06V58h-6v4h7.72L50 69.4V62h10v-4h-5zm-9 3v3.12L34.93 61 26 58.49V15l20 4.8V61zm-8.88-18.72a2 2 0 012.5-1.28l2.21.69a2 2 0 01-1.18 3.82l-2.21-.69a2 2 0 01-1.32-2.54z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/C2_Door_open.70caa355.svg";
export { SvgC2DoorOpen as ReactComponent };